import React from 'react';
import Heading from '@hubins/components/Heading';
import PepTable from './PepTable';
import ShowRawResponse from './ShowRawResponse';

const CompanyPepTemplate = ({ screening }) => {
  const pepHits =  screening?.result && Array.isArray(screening.result) ? screening.result.filter((res => (
    res?.isPep
  ))).length : 0;
  return (
    <>
      <div className='flex flex-direction-row space-between align-items-center s-bottom-l'>
        <Heading className='s-top-l' size="4">Hits: <span className={` ${pepHits > 0 ? 'c-danger' : 'c-success'}`}>{pepHits}</span></Heading>
        <ShowRawResponse screening={screening} />
      </div>
      {screening?.result && Array.isArray(screening.result) ? (
        <>
          {screening.result.map((res) => (
            <div className='s-bottom-l'>
              <Heading size="4">{res.name}</Heading>
              <PepTable screening={res} />
            </div>
          ))}
        </>
      ) : (
        <>No hits</>
      )}
    </>
  )
};

export default CompanyPepTemplate;